module.exports = __webpack_public_path__ + "media/pseudomembranous colitis.515eb47c.wav";